import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Check } from "lucide-react";

const plans = [
  {
    name: "Trial",
    description: "Try all features for 5 days",
    price: "Free",
    features: [
      "Full access to all features",
      "3 team seats",
      "Up to 20,000 contacts",
      "5,000 bulk emails/month",
      "1 workspace",
      "5 day trial period",
    ],
    current: true,
  },
  {
    name: "Pro",
    description: "Perfect for small teams",
    price: "$297",
    features: [
      "3 team seats included",
      "20,000 contacts",
      "5,000 bulk emails/month",
      "1 workspace",
      "Email tracking & analytics",
      "Priority email support",
    ],
    current: false,
  },
  {
    name: "Enterprise",
    description: "For large organizations",
    price: "Custom",
    features: [
      "Unlimited team seats",
      "Unlimited contacts",
      "Custom email volume",
      "Multiple workspaces",
      "Dedicated account manager",
      "Custom integrations & SLA",
    ],
    current: false,
  },
];

export function PlanSettings() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">Plans</h2>
        <p className="text-muted-foreground">
          Choose the plan that best fits your needs
        </p>
      </div>

      <div className="grid gap-6 lg:grid-cols-3">
        {plans.map((plan) => (
          <Card 
            key={plan.name}
            className={plan.current ? "border-primary" : undefined}
          >
            <CardHeader>
              <CardTitle>{plan.name}</CardTitle>
              <CardDescription>{plan.description}</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="mb-4">
                <span className="text-3xl font-bold">{plan.price}</span>
                {plan.price !== "Custom" && <span>/month</span>}
              </div>
              <ul className="space-y-2">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-center">
                    <Check className="h-4 w-4 mr-2 text-primary" />
                    {feature}
                  </li>
                ))}
              </ul>
            </CardContent>
            <CardFooter>
              <Button 
                className="w-full" 
                variant={plan.current ? "outline" : "default"}
              >
                {plan.current ? "Current Plan" : "Upgrade"}
              </Button>
            </CardFooter>
          </Card>
        ))}
      </div>
    </div>
  );
}